import * as React from 'react'
import {
  Collapsible as CollapsiblePrimitive,
  CollapsibleContent as CollapsibleContentPrimitive,
} from '@/components/ui/collapsible'

interface CollapseProps {
  children: React.ReactNode
  open: boolean
  className?: string
}

export function Collapse({ children, open, className }: CollapseProps) {
  return (
    <CollapsiblePrimitive open={open}>
      <CollapsibleContentPrimitive className={className}>
        {children}
      </CollapsibleContentPrimitive>
    </CollapsiblePrimitive>
  )
}
